<template>
  <v-dialog
    v-model="show"
    :persistent="options.persistent"
    :transition="transition"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    class="search-dialog"
  >
    <v-card height="550px">

      <v-toolbar
        flat
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="cancelDialog"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{formTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn
          @click="submit()"
          :disabled="!addressValid"
          dark
          flat
          style="min-width:0; font-weight:700;"
        >SUBMIT</v-btn>

      </v-toolbar>
      <v-card-text>
        <v-card
          v-show="!this.selectedAllergy"
          column
          flat
          class="mx-2 my-1"
        >

          <v-layout column>
            <v-form v-model="profileValid">
              <v-text-field
                flat
                class="mt-1 mb-1"
                v-model="firstNameInput"
                label="First Name"
              />
              <v-text-field
                flat
                class="mt-1 mb-1"
                v-model="lastNameInput"
                label="Last Name"
              />
              <v-text-field
                flat
                class="mt-1 mb-1"
                v-model="credentialsInput"
                label="Credentials"
              />
              <v-text-field
                flat
                class="mt-1 mb-1"
                v-model="orgNameInput"
                label="Organization Name"
              />
              <v-text-field
                flat
                class="mt-1 mb-1"
                :mask="phoneMask"
                v-model="phoneInput"
                label="Phone"
              />
              <v-text-field
                flat
                class="mt-1 mb-1"
                :mask="phoneMask"
                v-model="faxInput"
                label="Fax"
              />
              <v-text-field
                flat
                class="mt-1 mb-1"
                v-model="emailInput"
                label="Email"
              />
            </v-form>
            <v-form v-model="addressValid">
              <v-text-field
                flat
                class="mt-1 mb-1"
                label="Street Address"
                :rules="line1Rules"
                v-model="line1Input"
              ></v-text-field>

              <v-text-field
                flat
                class="mt-1 mb-1"
                label="Address Line 2"
                v-model="line2Input"
              ></v-text-field>

              <v-text-field
                flat
                class="mt-1 mb-1"
                label="City"
                :rules="cityRules"
                v-model="cityInput"
              ></v-text-field>

              <v-text-field
                class="mt-1 mb-1"
                hint="Two letter abbreviation"
                :rules="stateValidationRule"
                mask="AA"
                persistent-hint
                v-model="stateInput"
                label="State"
              ></v-text-field>

              <v-text-field
                flat
                class="mt-1 mb-1"
                label="Zip Code"
                :rules="zipRules"
                mask="#####"
                v-model="zipInput"
              ></v-text-field>
              <v-text-field
                multi-line
                flat
                class="mt-1 mb-1"
                label="Provider Notes"
                v-model="notesInput"
              ></v-text-field>

            </v-form>
          </v-layout>

        </v-card>
      </v-card-text>
      <!-- Results -->

      <!-- Input -->
      <!-- <v-card-text>
          <v-select class="form-input "
            solo flat
            :items="allergyList"
            v-model="formInput"
            label="Select an allergy..."
            single-line
            auto
            autocomplete
            ref="input"
            ></v-select>
        </v-card-text>   -->

      <!-- Selected Allergy -->
      <v-card
        flat
        v-if="selectedAllergy !== ''"
      >
        <v-card-text>
          <span class="dialogSectionTitle">{{ selectedAllergy }}</span>
          <!-- <v-card flat class=""> -->
          <!-- <v-card-text> -->
          <v-layout column>

            <div class="mb-2">

            </div>
            <v-layout
              column
              justify-center
            >
              <span
                class="dialogSectionTitle"
                style="opacity:.3;"
              >Select onset date (optional)</span>

              <v-date-picker
                flat
                class="mt-4"
                min-width="640px"
                style="margin:auto"
                v-model="date"
                no-title
              ></v-date-picker>

            </v-layout>
          </v-layout>
          <!-- </v-card-text>
            <v-card-actions>
            </v-card-actions>
          </v-card> -->
        </v-card-text>
      </v-card>

    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
@import '../../../styles/form';
$color: #1565c0;

.building {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  color: white;
  margin-left: 30px;
}

.content {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: #52535f;
  padding: 18px 15px;
  font-weight: bold;
}

.footer {
  border-top: 1px solid #e0e0e0;
}

.input {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 8px 16px;
  width: 100%;
  border-radius: 4px;
  font-size: 18px;
  // margin-top: 16px;
  background: white;
}

.outline {
  border: 1px solid #eeeeee;
}

.search-dialog {
  height: 100px;
}

.selected-title {
  font-size: 14px;
  font-weight: bold;
}

.dialog-height {
  min-height: 400px;
}
</style>

<script>
import { mapActions, mapState } from 'vuex'

import DialogMixin from '@/core/mixins/DialogMixin'
import FormTextarea from '@/core/components/FormTextarea'

export default {
  mixins: [DialogMixin],
  components: {
    FormTextarea
  },
  data() {
    return {
      profileValid: false,
      addressValid: false,
      formTitle: 'Edit Provider',
      notesInput: '',
      formInput: '',
      firstNameInput: '',
      credentialsInput: '',
      lastNameInput: '',
      phoneInput: '',
      emailInput: '',
      line1Input: '',
      line2Input: '',
      cityInput: '',
      stateInput: '',
      zipInput: '',
      faxInput: '',
      orgNameInput: '',
      selectedAllergy: '',
      date: null,
      dateFormatted: null,
      phoneMask: 'phone',
      menu: false,
      dateRule: [v => !!v || 'Start date is required'],
      valid: false,
      stateValidation: [
        'AL',
        'AK',
        'AS',
        'AZ',
        'AR',
        'CA',
        'CO',
        'CT',
        'DE',
        'DC',
        'FM',
        'FL',
        'GA',
        'GU',
        'HI',
        'ID',
        'IL',
        'IN',
        'IA',
        'KS',
        'KY',
        'LA',
        'ME',
        'MH',
        'MD',
        'MA',
        'MI',
        'MN',
        'MS',
        'MO',
        'MT',
        'NE',
        'NV',
        'NH',
        'NJ',
        'NM',
        'NY',
        'NC',
        'ND',
        'MP',
        'OH',
        'OK',
        'OR',
        'PW',
        'PA',
        'PR',
        'RI',
        'SC',
        'SD',
        'TN',
        'TX',
        'UT',
        'VT',
        'VI',
        'VA',
        'WA',
        'WV',
        'WI',
        'WY'
      ],
      phoneRules: [v => !!v || 'Phone number is required'],
      birthdateRules: [v => !!v || 'Birthdate is required'],
      line1Rules: [v => !!v || 'Street address is required'],
      cityRules: [v => !!v || 'City is required'],
      stateRules: [v => !!v || 'State is required'],
      stateValidationRule: [
        v => this.stateValidation.includes(v) || 'Invalid State'
      ],
      zipRules: [v => !!v || 'Zip Code is required']
    }
  },
  computed: {
    ...mapState('patient', ['patient']),
    results() {
      if (this.formInput) {
        return this.allergyList.filter(this.allergyMatch).slice(0, 5)
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapActions('provider', ['getInvidualProvider', 'getProviderAuth']),
    ...mapActions('admin', [
      'getPatient',
      'setStatus',
      'setProviderInfo',
      'createProvider'
    ]),
    allergyMatch(allergy) {
      return allergy.toLowerCase().includes(this.formInput.toLowerCase())
    },
    parseDate(date) {
      if (!date) return null
      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    submit() {
      if (this.options.id) {
        // get what is different, and update it.
        const provider = {}
        if (this.firstNameInput !== this.options.provider.firstName) {
          provider.firstName = this.firstNameInput
          provider.type = 'INDIVIDUAL'
        }
        if (this.lastNameInput !== this.options.provider.lastName) {
          provider.lastName = this.lastNameInput
          provider.type = 'INDIVIDUAL'
        }

        if (this.orgNameInput !== this.options.provider.organizationName) {
          provider.organizationName = this.orgNameInput
          if (!this.options.provider.lastName && this.lastNameInput === '') {
            provider.type = 'ORGANIZATION'
          }
        }

        if (this.credentialsInput !== this.options.provider.credentials) {
          provider.credentials = this.credentialsInput
        }

        if (this.notesInput !== this.options.provider.notes) {
          provider.notes = this.notesInput
        }

        if (this.phoneInput !== this.options.provider.phone) {
          if (this.phoneInput !== '') {
            provider.phone = parseInt(this.phoneInput)
          }
        }
        if (this.faxInput !== this.options.provider.fax) {
          if (this.faxInput !== '') {
            provider.fax = parseInt(this.faxInput)
          }
        }
        if (this.emailInput !== this.options.provider.email) {
          provider.email = this.emailInput
        }
        // the address has to be updated together
        let addressChanged = false
        if (this.options.provider.address) {
          if (this.line1Input !== this.options.provider.address.line1) {
            addressChanged = true
          }
          if (this.line2Input !== this.options.provider.address.line2) {
            addressChanged = true
          }
          if (this.cityInput !== this.options.provider.address.city) {
            addressChanged = true
            if (provider.address) {
              provider.address.city = this.cityInput
            } else {
              provider.address = {}
              provider.address.city = this.cityInput
            }
          }
          if (this.stateInput !== this.options.provider.address.state) {
            addressChanged = true
          }
          if (this.zipInput !== this.options.provider.address.zip) {
            addressChanged = true
          }
        } else {
          addressChanged = true
        }
        if (addressChanged) {
          provider.address = {}
          provider.address.line1 = this.line1Input
          provider.address.line2 = this.line2Input
          provider.address.city = this.cityInput
          provider.address.state = this.stateInput
          provider.address.zip = this.zipInput
        }
        let info = provider
        this.setProviderInfo({
          id: this.options.provider.id,
          info
        }).then(() => {
          this.$emit('providerUpdated')
        })
      } else {
      }
      this.ok()
    },
    cancelDialog() {
      this.formInput = ''
      this.selectedAllergy = ''
      this.cancel()
    },
    convertToUnix(date) {
      if (date !== '') {
        const splitDate = date.toString().split('/')
        const formatDate =
          splitDate[0] + '.' + splitDate[1] + '.' + splitDate[2]
        // Format: '2012.08.10'
        return new Date(formatDate).getTime() / 1000
      }
    },
    onClose() {
      this.opened = false
    },
    onOpen() {
      console.log('opening')
      if (this.options.id) {
        // get the provider.
        this.firstNameInput = this.options.provider.firstName
        this.lastNameInput = this.options.provider.lastName
        this.orgNameInput = this.options.provider.organizationName
        this.phoneInput = this.options.provider.phone
        this.faxInput = this.options.provider.fax
        this.emailInput = this.options.provider.email
        this.notesInput = this.options.provider.notes
        this.credentialsInput = this.options.provider.credentials
        if (this.options.provider.address) {
          this.stateInput = this.options.provider.address.state
          this.zipInput = this.options.provider.address.zip
          this.line1Input = this.options.provider.address.line1
          this.line2Input = this.options.provider.address.line2
          this.cityInput = this.options.provider.address.city
        }
      } else {
        console.log('this is a brand new doc')
        this.formTitle = 'Add New Provider'
      }
    }
  },
  watch: {
    formInput(val) {
      if (this.formInput !== '') {
        this.selectedAllergy = ''
      }
    },
    date(val) {
      this.dateFormatted = this.formatDate(this.date)
    }
  },
  mounted() {
    this.$on('open', this.onOpen)
    this.$on('close', this.onClose)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/AddEditProviderDialog.vue